import { createIcons } from "@toruslabs/vue-components";

import Icons from "../icons";

export default createIcons(Icons);